import React from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { Card, CardBody, CardSubtitle } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faTicket } from "@fortawesome/free-solid-svg-icons";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import { useHistory, useLocation } from "react-router-dom";
import Guest from "../../../layouts/Guest";
import { useGuestContext } from "../../../contexts/GuestContext";
import { LIANG_HUANG_EVENT, LIANG_HUANG_SESSIONS } from "../../../config/liangHuang2026";

function EventTicket() {
  const { language } = useGuestContext();
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(window.location.search);
  const guestId = location.state?.guestId || params.get("guestid") || params.get("id");
  const sessionSelections = location.state?.sessionSelections;
  const ticketSessions = sessionSelections
    ? LIANG_HUANG_SESSIONS.filter((session) => sessionSelections[session.field])
    : LIANG_HUANG_SESSIONS;
  const formattedGuestId = guestId ? String(guestId).padStart(4, "0") : "----";
  const qrValue = `${window.location.origin}/event/checkin?guestid=${guestId || ""}`;

  const downloadImage = async () => {
    const canvas = await html2canvas(document.getElementById("ticket-for-download"), {
      scale: 1,
      useCORS: true,
    });
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/jpeg", 1.0);
    link.download = `lianghuang-2026-ticket-${guestId}.jpg`;
    link.click();
  };

  const cardBackgroundStyle = {
    backgroundImage: `linear-gradient(to left, rgba(255,255,255,.78), rgba(255,255,255,.98)), url(${require("../../../assets/img/baolinPrivate/2025lianghuang.png")})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
    <Guest>
      <div className="content p-0">
        <Container>
          <Card className="card-box mb-4 p-4" id="ticket-for-download" style={cardBackgroundStyle}>
            <h3 className="font-weight-bold text-info mb-1">{LIANG_HUANG_EVENT.title.Chinese}</h3>
            <span className="font-weight-bold d-block mb-3">{LIANG_HUANG_EVENT.title.English}</span>
            <hr />
            <Row>
              <Col md={4} className="d-flex flex-column align-items-center justify-content-center mb-4">
                <Card className="bg-light text-center mb-3">
                  <CardBody>
                    <CardSubtitle className="mb-2 font-weight-bold">Guest ID</CardSubtitle>
                    <span className="text-guest-id">{formattedGuestId}</span>
                  </CardBody>
                </Card>
                <QRCodeCanvas value={qrValue} size={170} level="H" />
                <span className="mt-3 text-center">請提早30分鐘報到</span>
                <span className="text-center">Please arrive 30 minutes early</span>
              </Col>
              <Col md={8}>
                <h4 className="font-weight-bold text-center mb-3">日程安排 | Session Schedule</h4>
                <div className="table-responsive">
                  <Table striped size="sm">
                    <thead>
                      <tr><th>Scroll</th><th>Date</th><th>Time</th></tr>
                    </thead>
                    <tbody>
                      {ticketSessions.map((session) => (
                        <tr key={session.field}>
                          <td>Scroll {session.scroll}<br />卷{["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"][session.scroll - 1]}</td>
                          <td>{session.date.English}<br />{session.date.Chinese}</td>
                          <td>{session.time}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </Card>
          <Row className="mb-5">
            <Col md={6} className="mb-2">
              <Button variant="primary" block onClick={downloadImage}>
                <FontAwesomeIcon icon={faTicket} /> {language === "English" ? "Download ticket" : "下載入場券"}
              </Button>
            </Col>
            <Col md={6}>
              <Button variant="warning" block onClick={() => history.push("/register")}>
                {language === "English" ? "Register another person" : "繼續報名"} <FontAwesomeIcon icon={faArrowRight} />
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </Guest>
  );
}

export default EventTicket;
